module.exports = __webpack_public_path__ + "img/rock-huge-17.64416c7f.png";